export enum MetadataStatusEnum {
  ALL = "ALL",
  READY_TO_BOOK = "READY_TO_BOOK",
  BOOKING_REQUESTED = "BOOKING_REQUESTED",
  ARCHIVED = "ARCHIVED",
  PENDING_DELIVERY = "PENDING_DELIVERY",
  IN_TRANSIT = "IN_TRANSIT",
  DELIVERED = "DELIVERED",
  PENDING = "PENDING",
  PENDING_AIRLINE_INFORMATION = "PENDING_AIRLINE_INFORMATION",
  EXPIRED = "EXPIRED",
  PENDING_AIRLINE = "PENDING_AIRLINE",
}
